import { useAccountChange } from '@lair-finance/wagmi'
import { getAuthStore } from '@/domains/auth/model/store.ts'

export function useResetAuthOnAccountChange() {
  useAccountChange((account, prevAccount) => {
    if (account.address !== prevAccount.address) {
      getAuthStore().reset()
    }
  })
}
